import React, { useState } from "react";
import TabLink from "./TabLink";
import { Flex } from "@chakra-ui/react";
import TabLinkNew from "./TabLinkNew";

const TabContainer = ({ tabs, isSideBarTiny }) => {
  // console.log("tabs", tabs);

  // const [activeAccordion, setActiveAccordion] = useState(null);
  const [activeAccordion, setActiveAccordion] = useState(() => {
    // Find the first menu that should be open
    const openMenu = tabs.find(
      (tab) =>
        tab.hasSubMenu &&
        tab.subMenuItems.some((sub) =>
          window.location.pathname.startsWith(sub.route)
        )
    );

    return openMenu ? openMenu.id : null;
  });

  const handleAccordionToggle = (menuId, hasSubMenu) => {
    // console.log("menuId", menuId);
    // console.log("hasSubMenu", hasSubMenu);

    if (hasSubMenu) {
      setActiveAccordion((prev) => (prev === menuId ? null : menuId)); // Toggle only one open accordion
    } else {
      setActiveAccordion(null); // Clicking normal menu closes all accordions
    }
  };

  // console.log("activeAccordion", activeAccordion);
  // console.log("tabs", tabs);

  return (
    <>
      <Flex
        p={isSideBarTiny ? "1rem 0 0 1rem" : "1rem 0 0 2rem"}
        direction="column"
        w="100%"
        h="100%"
        overflowY="auto"
        overflowX="hidden"
        className="customScrollbar"
      >
        {tabs.map((tab) => (
          <TabLinkNew
            key={tab.id}
            {...tab}
            isSideBarTiny={isSideBarTiny}
            isAccordionOpen={activeAccordion === tab.id}
            onAccordionToggle={() =>
              handleAccordionToggle(tab.id, tab.hasSubMenu)
            }
            activeAccordion={activeAccordion}
            setActiveAccordion={setActiveAccordion}
          />
        ))}
      </Flex>
    </>
  );
};

export default TabContainer;
